import * as React from 'react';
import type { SVGProps } from 'react';

const CloseSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"  {...props}>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M5.1716 8.00003L0.585815 3.41424L3.41424 0.585815L8.00003 5.1716L12.5858 0.585815L15.4142 3.41424L10.8285 8.00003L15.4142 12.5858L12.5858 15.4142L8.00003 10.8285L3.41424 15.4142L0.585815 12.5858L5.1716 8.00003Z"
          fill="#616061" />
  </svg>
);

export default CloseSvg;